import { S } from "../theme";

function MobileHeader({ setMobileOpen, active }) {
  const labels = { dashboard: "Dashboard", protocol: "My Protocol", track: "Track Today", biomarkers: "Biomarkers", injections: "Injection Sites", library: "Peptide Library", ai: "AI Guidance", community: "Community", blog: "Blog", fda: "FDA Updates", pricing: "Plans & Pricing", settings: "Settings" };
  return (
    <div className="tmp-mobile-header" style={{ display: "none", padding: "14px 18px", background: S.darkPanel, alignItems: "center", justifyContent: "space-between", position: "sticky", top: 0, zIndex: 40, borderBottom: "1px solid rgba(255,255,255,0.06)" }}>
      <button onClick={() => setMobileOpen(true)} style={{ background: "rgba(255,255,255,0.08)", border: "none", color: "#fff", padding: "8px 12px", borderRadius: 10, cursor: "pointer", fontSize: "1.1rem", lineHeight: 1 }}>☰</button>
      <div style={{ fontFamily: "'Fraunces', serif", fontWeight: 800, fontSize: "0.95rem", color: "#fff" }}>{labels[active] || "TrackMyPeptide"}</div>
      <div style={{ width: 40 }}></div>
    </div>
  );
}

// ─── DASHBOARD ───────────────────────────────────────────────

export { MobileHeader };
